module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0110.jpg?v=78d82496";